module.exports = self.React
